export enum Platform {
  iPhone = 'iPhone',
}

const getPlatform = () => window?.navigator?.platform;

export const isIPhone = () => getPlatform() === Platform.iPhone;
